/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_BRANCH_CONTACT_TITLES, GET_BRANCH_CONTACT_TITLES } from 'src/actions/branchContactTitleActions';

const initialState = {
  branchContactTitles: [],
  isFetching: false,
  message: ''
};

const branchContactTitleReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BRANCH_CONTACT_TITLES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_BRANCH_CONTACT_TITLES: {
      const { branchContactTitles, message } = action.payload;

      return produce(state, (draft) => {
        draft.branchContactTitles = branchContactTitles;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default branchContactTitleReducer;
